import React, { useState, useEffect } from "react";
import { Modal, Box, Avatar, IconButton, TextField, Button, Divider, FormControl, InputLabel, Select, OutlinedInput, MenuItem, Chip } from "@mui/material";
import { useAuth0 } from '@auth0/auth0-react';
import { FaUserCircle } from 'react-icons/fa';
import EditIcon from "@mui/icons-material/Edit";

import localization from '../../services/localization';

const ProfileModal = ({ open, onClose, theme }) => {
    const [localTheme, setLocalTheme] = useState(theme);
    const { user, logout } = useAuth0();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        institution: "",
        grade: [],
        subject: [],
    });

    const grades = ["Grade 1", "Grade 2", "Grade 3", "Grade 4", "Grade 5"];
    const subjects = ["Math", "Science", "History", "English", "Geography"];

    useEffect(() => {
        setLocalTheme(theme);
    }, [theme]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        console.log("Form submitted:", formData);
    };

    const handleProfilePicChange = () => {

    }
    const handleMultiSelectChange = (event, fieldName) => {
        const { value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };
    return (
        <Modal open={open} onClose={onClose} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box
                sx={{
                    width: "50%",
                    height: "auto",
                    backgroundColor: localTheme === "light" ? "#ececec" : "rgba(50,50,50,0.95)",
                    color: localTheme === "light" ? "#000" : "#ececec",
                    borderRadius: "10px",
                    padding: "2rem",
                    boxShadow: 24,
                    overflowY: "auto",
                    textAlign: "center",
                }}>
                <Box sx={{ position: "relative", display: "inline-block", marginBottom: "1.5rem" }}>
                    {user?.picture ? (
                        <Avatar src={user.picture} alt={user.name} sx={{ width: 100, height: 100, margin: "auto" }} />
                    ) : (
                        <FaUserCircle size={100} style={{ color: "grey" }} />
                    )}
                    <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        id="profile-pic-upload"
                        onChange={handleProfilePicChange}
                    />
                    <label htmlFor="profile-pic-upload">
                        <IconButton
                            component="span"
                            sx={{
                                position: "absolute",
                                bottom: 0,
                                right: 0,
                                backgroundColor: "rgba(0,0,0,0.6)",
                                color: "#fff",
                                "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                            }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </label>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Box sx={{ display: "flex", gap: "1rem" }}>
                        <TextField label="First Name" name="firstName" variant="outlined" fullWidth value={formData.firstName} onChange={handleChange} />
                        <TextField label="Last Name" name="lastName" variant="outlined" fullWidth value={formData.lastName} onChange={handleChange} />
                    </Box>
                    <Box sx={{ display: "flex", gap: "1rem" }}>
                        <TextField label="Email" name="email" type="email" variant="outlined" fullWidth value={formData.email} onChange={handleChange} />
                        <TextField label="Phone Number" name="phone" type="tel" variant="outlined" fullWidth value={formData.phone} onChange={handleChange} />
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <TextField label="Institution" name="institution" variant="outlined" fullWidth value={formData.institution} onChange={handleChange} />

                    <FormControl fullWidth>
                        <InputLabel>{localization.grade || "Grade"}</InputLabel>
                        <Select multiple value={formData.grade} onChange={(e) => handleMultiSelectChange(e, "grade")} input={<OutlinedInput label="Grade" />} renderValue={(selected) => selected.join(", ")}>
                            {grades.map((grade) => (
                                <MenuItem key={grade} value={grade}>
                                    <Chip label={grade} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel>{localization.subject || "Subject"}</InputLabel>
                        <Select multiple value={formData.subject} onChange={(e) => handleMultiSelectChange(e, "subject")} input={<OutlinedInput label="Subject" />} renderValue={(selected) => selected.join(", ")}>
                            {subjects.map((subject) => (
                                <MenuItem key={subject} value={subject}>
                                    <Chip label={subject} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ marginTop: "1.5rem", padding: "0.75rem", fontWeight: "bold" }}
                    onClick={handleSubmit}
                >
                    {localization.submit || "Submit"}
                </Button>
            </Box>
        </Modal>
    )
};

export default ProfileModal;